import styled from 'styled-components';

export const ProductsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0 24px;
    position: relative;
`;

export const ProductsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: calc(80vh - 76px - 72px);
    overflow-y: auto;
    padding-right: 4px;
    scrollbar-width: none;
    -ms-overflow-style: none;
    position: relative;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const ProductArea = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    border-bottom: 1px solid
        ${(props) =>
            props.theme.theme === 'light'
                ? '#f0f0f0'
                : props.theme.colors.antdBorder};
    padding: 12px 24px;
    box-sizing: border-box;
    position: relative;
`;

export const ProductFigureArea = styled.div`
    width: 79px;
    height: 79px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ProductTitle = styled.h1`
    font-size: 16px;
    color: ${(props) => (props.theme.theme === 'light' ? '#262626' : '#fff')};
    margin: 0;
    font-weight: 400;
`;

export const ImageWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 8px;
    box-sizing: border-box;
`;

export const ProductInfoArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ProductInfo = styled.div`
    display: flex;
    gap: 15px;
`;

export const BarCodeArea = styled.div`
    display: flex;
    align-items: center;
    color: #b0b0b0;
`;

export const CategoryProduct = styled.div`
    background: #e5f0ff;
    color: #30374a;
    display: flex;
    justify-content: center;
    border-radius: 4px;
    height: 22px;
    align-items: center;
    padding: 0 8px;
`;

export const BackgroundTransparent = styled.div`
    position: absolute;
    height: 60px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
    left: 0;
    right: 0;
    bottom: 0;
`;

export const StoreName = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #b0b0b0;
`;
